import { LoadingButton } from "@mui/lab";
import {
	Autocomplete,
	Box,
	Button,
	CardContent,
	Chip,
	TextField,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useAuthContext } from "src/components/Context/AuthContext/AuthContext";
import { url } from "src/Helpers/utils/constants";
import Toaster from "src/Toaster/Toaster";
import { Imembers } from "src/Types/module/member/memberTypes";
import { muiStyles } from "src/Utils/Styles";

const useStyles = muiStyles;

const SingleSMS = () => {
	const classes = useStyles();
	const { user } = useAuthContext();
	const [allMember, setAllMember] = useState<Imembers[]>([]);
	const [isLoading, setisLoading] = useState<boolean>(false);
	const [isMSgsent, setisMsgSent] = useState<boolean>(false);
	const [membersId, setMembersId] = useState<string[]>([]);
	const Toast = Toaster();
	const [text, setText] = useState<string>("");

	useEffect(() => {
		setisLoading(true);
		(async function () {
			try {
				// let uri = `${url}/api/user-member/get/all/by/zone/status/for-admin/${user.}/all`;

				let uri;

				if (user.user_admin_role === "Super Admin") {
					uri = `${url}/api/user-member/get/all/by/zone/status/for-admin/all/all`;
				}
				const { data } = await axios.get(uri);
				if (data.success) {
					setAllMember(data.data);
					setisLoading(false);
				} else {
					setisLoading(false);
				}
			} catch (error) {
				setisLoading(false);
			}
		})();
	}, []);

	membersId;

	const handleSubmit = async (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault();
		setisMsgSent(true);
		const selectedMember = membersId.map((member) => {
			return parseInt(member.split(" ")[0]);
		});

		const body = {
			member_id: selectedMember,
			message: text,
		};

		body;

		try {
			const { data } = await axios.post(
				`${url}/api/user-member/send/sms`,
				body
			);
			({ data });
			if (data.success) {
				Toast.fire({
					icon: "success",
					title: `Message sent Successfully`,
				});
				setisMsgSent(false);
				setText("");
			}
		} catch (err) {
			Toast.fire({
				icon: "success",
				title: `Message doesn't sent`,
			});
			setisMsgSent(false);
		}
	};
	return (
		<CardContent>
			<Box
				component='form'
				onSubmit={(e: React.ChangeEvent<HTMLInputElement>) =>
					handleSubmit(e)
				}
				sx={{ p: 2 }}
				className=''
			>
				{!isLoading && (
					<Autocomplete
						multiple
						id='tags-filled'
						options={allMember.map(
							(option) =>
								option.user_member_id +
								" " +
								option.user_member_representative_name
						)}
						freeSolo
						onChange={(event, newValue) => {
							setMembersId(newValue);
						}}
						renderTags={(value: readonly any[], getTagProps) =>
							value.map((option: any, index: number) => (
								<Chip
									variant='filled'
									label={option}
									{...getTagProps({ index })}
								/>
							))
						}
						renderInput={(params) => (
							<TextField
								{...params}
								label='Member'
								placeholder='More..'
							/>
						)}
					/>
				)}
				<TextField
					margin='normal'
					required
					fullWidth
					id='message'
					label='Message '
					autoComplete='message'
					autoFocus
					onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
						setText(e.target.value)
					}
					value={text}
					multiline
					minRows={10}
					variant='filled'
					className={classes.inputText}
					InputProps={{ classes }}
				/>
				{!isMSgsent ? (
					<Button
						type='submit'
						fullWidth
						variant='contained'
						disableElevation
						sx={{
							mt: 3,
							mb: 2,
							py: 1,
						}}
					>
						Send message
					</Button>
				) : (
					<LoadingButton
						type='submit'
						loading={isMSgsent}
						fullWidth
						color='secondary'
						disableElevation
						sx={{
							mt: 3,
							mb: 2,
							py: 1,
						}}
						className={classes.signInButton}
						loadingPosition='end'
						variant='contained'
					>
						Loading
					</LoadingButton>
				)}
			</Box>
		</CardContent>
	);
};

export default SingleSMS;
